import { CommonModule } from '@angular/common';
import { Component, Input, ContentChild, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { NickyButtonComponent } from 'src/app/components/form/nicky-button/nicky-button.component';
import { AuthStore } from 'src/app/stores/auth.store';
import { getValidLanguage } from 'src/app/utils/get-valid-language-util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-error-state',
  imports: [CommonModule, NickyButtonComponent, TranslateModule],
  templateUrl: './error-state.component.html',
})
export class ErrorStateComponent implements OnInit {
  protected route = inject(ActivatedRoute);
  protected translate = inject(TranslateService);
  protected authStore = inject(AuthStore);
  private isAuthenticated$ = inject(AuthService).isAuthenticated$;

  @Input() title: string = 'ERROR.somethingWentWrong';
  @Input() subtitle: string | undefined = 'ERROR.weEncounteredAnErrorWhileProcessingYourRequest';
  @Input() hasCustomButtons: boolean = false;
  @Input() backButtonText: string = 'ERROR.goBack';
  @ContentChild('errorButtons') errorButtons: any;

  ngOnInit() {
    const reason = this.route.snapshot.queryParamMap.get('reason');
    if (reason === 'profile-not-found') {
      this.title = 'ERROR.profileNotFound';
      this.subtitle = 'ERROR.theProfileYouAreLookingForDoesNotExistOrHasBeenRemoved';
      this.backButtonText = 'ERROR.goHome';
    }
    const language = this.authStore?.profile?.()?.language || getValidLanguage(navigator.language);
    this.translate.use(language);
  }

  async handleBackNavigation(): Promise<void> {
    // Redirect to overview page or website
    const isAuthenticated = await firstValueFrom(this.isAuthenticated$);
    window.location.href = isAuthenticated ? '/overview' : environment.websiteUrl;
  }
}
